import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import { NormalTable } from '../../Tables/NormalTable/NormalTable';
import { get } from '../../../Model/Network/Config/Axios';


const ChangeLog = (props) => {
	const [audit, setAudit] = useState([]);

	useEffect(() => {
		if (props.voucherId) {
			get(`settlements/vouchers/${props.voucherId}/details`, (e, r) => {
				if (r) {
					setAudit(r.audit);
				}
			});
		}
	}, [props.voucherId]);

	let mapItem = (item, index) => {
        return (
            <div key={index} style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 10, height: 60 }}
                className="border-bottom fintrip-department-item table-item"
            >
                <div className="linear-layout horizontal"
                    style={{ flex: 1, cursor: 'pointer', alignItems: 'center' }}
                >
                    <div style={{
                        flex: 3
                    }}>
                        <p style={{
                            fontWeight: 600,
                            fontSize: 16
                        }}>{item.log}</p>

                        <p className="bottom">{item.remarks ? item.remarks : ""}</p>
                    </div>
                    <div style={{
                        flex: 1,
                        textAlign: 'right'
                    }}>
                        <p style={{ fontSize: 13, fontWeight: 600 }}>{Moment(item.time).format('DD/MM/YYYY hh:mm a')}</p>
                        <p className="bottom" style={{
                            marginTop: 1,
                            marginBottom: 1,
                            fontSize: 12
                        }}>Action taken By : {item.ownerType}</p>
                    </div>
                </div>
            </div>
        )
    }


	if (audit.length === 0) {
		return (<p>No Logs Found</p>)
	}
	return (
		<div>
			 <NormalTable
                    headers={[]}
                    data={audit}
                    pagination={false}
                    mapItem={mapItem}
                    headerStyle={{
                        borderBottom: 'none',
                    }}
                />
		</div>
	);

}

export default ChangeLog
